import React from "react";
import moment from "moment";
import { Table, TableHeader, TableBody, TableRow, TableHeaderCell, TableCell, Box } from "@sainsburys-tech/fable";
import PropTypes from "prop-types";
import OverrideStageIcon from "../OverrideStageIcon";

const sortTimeInMilliseconds = (accessor, ascending) => (a, b) => {
  const Item1valueA = parseInt(accessor(a).timeInMilliseconds, 0);
  const Item2valueA = parseInt(accessor(b).timeInMilliseconds, 0);
  if (Item1valueA < Item2valueA) {
    return ascending ? -1 : 1;
  }
  if (Item1valueA > Item2valueA) {
    return ascending ? 1 : -1;
  }
  return 0;
};

const sortStatus = status => {
  switch (status) {
    case "Completed":
      return 1;
    case "Posting":
      return 2;
    case "Failed":
      return 3;
    default:
      return 1;
  }
};

const OverridesGroupedListTable = props => (
  <Box>
    <Table isResponsive={true} layout="fixed">
      <TableHeader>
        <TableRow>
          <TableHeaderCell>Name</TableHeaderCell>
          <TableHeaderCell>Zone(s)</TableHeaderCell>
          <TableHeaderCell>Start time & date</TableHeaderCell>
          <TableHeaderCell>End time & date</TableHeaderCell>
          <TableHeaderCell>Last updated</TableHeaderCell>
          <TableHeaderCell>Status</TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {props.data.map((item, index) => (
          <TableRow key={index}>
            <TableCell>{item.store}</TableCell>
            <TableCell>{item.zones}</TableCell>
            <TableCell>
              {new moment(item.start).format("HH:mm") +
                " - " +
                new moment(item.start).format("DD/MM/YY")}
            </TableCell>
            <TableCell>
              {new moment(item.end).format("HH:mm") +
                " - " +
                new moment(item.end).format("DD/MM/YY")}
            </TableCell>
            <TableCell>{moment(item.created).format("DD/MM/YY")}</TableCell>
            <TableCell>
              <span className="fable:flex fable:items-center">
                <span className="fable:mr-2">
                  <OverrideStageIcon stage={item.stage.stage.description} />
                </span>
                {item.stage.stage.description}
              </span>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Box>
);

OverridesGroupedListTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      overrideName: PropTypes.string,
      store: PropTypes.string,
      zones: PropTypes.string,
      start: PropTypes.Date,
      end: PropTypes.Date,
      stage: PropTypes.shape({
        storeId: PropTypes.string,
        stage: PropTypes.shape({
          name: PropTypes.string,
          description: PropTypes.string
        })
      }),
      created: PropTypes.Date
    })
  )
};
export default OverridesGroupedListTable;
